import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {productUserEntitlementConflictChecker} from 'src/openapi/admin/apis/ProductUserEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {EntitlementConflictRequest} from 'src/openapi/admin/models/EntitlementConflictRequest';

type Props = {
    userId: number,
    entitlementConflictRequest: EntitlementConflictRequest,
};

export const useGetProductUserEntitlementsConflicts = ({userId, entitlementConflictRequest}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        productUserEntitlementConflictChecker({userId, entitlementConflictRequest}),
    ), [userId, apiDispatch, entitlementConflictRequest]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
